module.exports = __webpack_public_path__ + "img/LUPINE.1e85b1d5.png";